/* __next_internal_client_entry_do_not_use__ BlogEntryLink auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { blogPage } from "@faire/retailer-visitor-shared/paths/index";
import { useLocalization } from "@faire/web--source/common/localization/useLocalization";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackLoggedOutRetailersDeepLinkBlogClick } from "@faire/web-api--source/events/loggedOutRetailers/click/deepLinkBlog";
import React from "react";
import { HeaderAnchor } from "../styled";
export var BlogEntryLink = function() {
    var _useLocalization = useLocalization(), locale = _useLocalization.intl.locale;
    return /*#__PURE__*/ _jsx(HeaderAnchor, {
        href: "".concat(blogPage(locale), "/"),
        "data-test-id": "blogEntryButton",
        onClick: function() {
            return trackLoggedOutRetailersDeepLinkBlogClick("blog", "desktop");
        },
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "oe71Qa",
            defaultMessage: [
                {
                    type: 0,
                    value: "Blog"
                }
            ]
        })
    });
};
